<template>
    <div class="content">
        <!-- <div v-if="!isSelect"> -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="text">查询条件</span>
                </div>
                <div class="box-cont">
                    <el-form :model="queryParams" ref="queryForm" :inline="true">
                        <el-form-item label="单位名称:" prop="dwmc">
                            <el-input style="width:65%;"
                            v-model="queryParams.dwmc"
                            placeholder="请输入单位名称"
                            clearable
                            size="small"
                            @keyup.enter.native="handleQuery"
                            />&nbsp;
                            <el-button type="primary" size="small" @click="getPhone()">调取手机端</el-button>
                        </el-form-item>
                        <el-form-item label="专业类别:" prop="zylb">
                            <el-select v-model="queryParams.zylb" clearable placeholder="请选择专业类别" size="small">
                                <el-option
                                    v-for="dict in zylbOptions"
                                    :key="dict.ID"
                                    :label="dict.mc"
                                    :value="dict.ID"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="库别:" >
                            <el-checkbox-group v-model="checkList" @change="getCheck()">
                                <el-checkbox label="有效库" value="0"></el-checkbox>
                                <!-- <el-checkbox label="过期库"></el-checkbox> -->
                                <el-checkbox label="无证库" value="1"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item style="text-align:right;">
                            <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                            <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="text">查询结果</span>
                    <p>单位数量:<b>{{total}}</b>个</p>
                </div>
                <div class="box-cont">
                    <el-table v-loading="loading" :data="ajslList">
                        <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                            <template slot-scope="scope">
                                <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="库别" align="center" prop="kubie" width="90"  />
                        <el-table-column label="监督对象名称" prop="dwmc" />
                        <el-table-column label="专业类别" align="center" prop="zylb" width="120"  />
                        <el-table-column label="许可证号" prop="xkzh" />
                        <el-table-column label="单位地址" prop="dwdz" />
                        <el-table-column label="负责人" align="center" prop="jingyingzhexm" width="90"  />
                        <el-table-column label="负责人电话" align="center" prop="sj1" width="120" />
                        <el-table-column label="选择" align="center" class-name="small-padding fixed-width" width="80" >
                            <template slot-scope="scope">
                                <el-button 
                                size="small"
                                type="text"
                                @click="handleSelect(scope.row)"
                            >选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page-part" style="padding:20px 20px 50px;">
                        <el-pagination  v-if="pageshow"
                            background
                            @size-change='handleSizeChange'
                            @current-change='handleCurrentChange'
                            :current-page="queryParams.page"
                            :page-sizes="[10,20,30,40]"
                            :page-size="queryParams.limit"
                            layout="total, prev, pager, next, jumper"
                            :total="total" style=" float:right;">
                        </el-pagination>
                    </div>
                </div>
            </el-card>
        <!-- </div>
        <div v-if="isSelect">
            <baxq :dwId="this.dwId" :dwFlag="this.dwFlag" :isNew="1" @handleBack="handleBack"  />
        </div> -->
        


        <el-dialog title="现场笔录信息" :visible.sync="open" top="5vh" width="1200px" append-to-body :close-on-click-modal="false">
            <el-form :model="queryParams2" ref="queryForm2" :inline="true">
                <el-form-item label="单位名称(个人名称):" prop="dwmc">
                    <el-input
                    v-model="queryParams2.dwmc"
                    placeholder="请输入单位名称(个人名称)"
                    clearable
                    size="small"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="getPhone()">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="loading" :data="xcblList" style="max-height:500px;overflow-y:auto;">
                        <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                            <template slot-scope="scope">
                                <span>{{(scope.$index+1)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="单位名称" prop="dwmc" />
                        <el-table-column label="执法类别" align="center" prop="ssjType" width="110"  />
                        <el-table-column label="处罚" prop="ischufa" width="50"  />
                        <el-table-column label="检测" prop="isjiance" width="50" />
                        <el-table-column label="专业类别" prop="zflb" width="90" />
                        <el-table-column label="检查人员1" align="center" prop="jdy1" width="90" />
                        <el-table-column label="检查人员2" align="center" prop="jdy2"  width="90" />
                        <el-table-column label="检查日期" align="center" prop="bl_date" width="110"  />
                        <el-table-column label="记录有无" align="center" width="80" >
                            <template slot-scope="scope">
                                <span v-if="scope.row.xcbl_bh">有</span>
                                <span v-else>无</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="选择" align="center" class-name="small-padding fixed-width" width="100" >
                            <template slot-scope="scope">
                               <el-checkbox @change="handleSelect2(scope.row)"></el-checkbox>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align:center;">
                        <el-button type="primary" @click="queding">确 定</el-button>
                    </div>
        </el-dialog>

    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import Baxq from './baxq.vue'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            dm:'',
            cmid:'',
            xm1:'',
            sj1:'',
            xm2:'',
            sj2:'',
            queryParams:{
                dwmc:'',
                zylb:'',
                kubie:'2',
                page:1,
                limit:10,
            },
            total:0,
            ajslList:[],
            zylbOptions:[],
            checkList:[],
            open:false,
            pageshow:true,
            ajId:'',
            dwId:'',
            dwFlag:'',
            open2:false,
            form:{},
            rules:{
                jingyingzhe:[
                    { required: true, message: '经营者性质不能为空', trigger: 'blur' }
                ],
                dwmc:[
                    { required: true, message: '单位(个人)名称不能为空', trigger: 'blur' }
                ],
                zylb:[
                    { required: true, message: '专业类别不能为空', trigger: ['change','blur'] }
                ],
                jingyingzheXm:[
                    { required: true, message: '经营者姓名不能为空', trigger: 'blur' }
                ],
                dwdz:[
                    { required: true, message: '注册地址不能为空', trigger: 'blur' }
                ],
                frxb:[
                    { required: true, message: '性别不能为空', trigger: ['change','blur'] }
                ],
                nation:[
                    { required: true, message: '民族不能为空', trigger: ['change','blur'] }
                ],
                frzw:[
                    { required: true, message: '职务不能为空', trigger: ['change','blur'] }
                ],
                sfzh:[
                    { required: true, message: '身份证号不能为空', trigger: 'blur' }
                ],
                sj1:[
                    { required: true, message: '联系电话不能为空', trigger: 'blur' }
                ],
                zzdm:[
                    { required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }
                ],
                changsuo:[
                    { required: true, message: '违法行为发生的单位名称/场所不能为空', trigger: 'blur' }
                ],
                wfxwdz:[
                    { required: true, message: '违法行为发生的地址不能为空', trigger: 'blur' }
                ]
            },
            weixinOptions:[],
            jingyingzheOptions:[],
            xiangjiedaoOptions:[],
            mzOptions:[],
            zwOptions:[],
            isSelect:false,
            cmid:'',
            xcblList:[],
            open:false,
            queryParams2:{
                dwmc:''
            },
            sc: "",
            xg: "",
            xz: "",
            baseUrl:''

        }
    },
    components: {
        Baxq
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '一般程序处罚案件受理'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        console.log(this.xg)
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        this.dm = user.dm
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/xx/selectFaRenType`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid,
            }
        })
        .then(response => {
            console.log(response.data,1194)
            if (response.data && response.data.data) {
                this.jingyingzheOptions = response.data.data || []
            }
            this.loading = false
        })
        .catch(error => {
            this.loading = false
            this.$message.error('获取数据失败！');
            console.error('There was an error!', error);
        }); 
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZylb`,
            data:{
                 "cfxt":""
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylbOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        
        this.getList()
    },
    methods: {
        getList(){
            this.ajslList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getybcxcfajsl`,
                data:{
                    zylb:this.queryParams.zylb,
                    dwmc:this.queryParams.dwmc,
                    kubie:this.queryParams.kubie,
                    cmid:this.cmid,
                    limit:this.queryParams.limit,
                    page:this.queryParams.page
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                this.loading = false
                if(res.data.code == 0 && res.data.data){
                    this.ajslList = res.data.data.list || []
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.loading = false
                this.$message.error(error);
            })
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        resetQuery(){
            this.queryParams.page = 1
            this.queryParams = {
                dwmc:'',
                zylb:'',
                kubie:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        getCheck(){
            console.log(this.checkList)
            if(this.checkList){
                if(this.checkList.length == 1){
                    this.queryParams.kubie = this.checkList[0] == '有效库' ? 0:1
                }else{
                    this.queryParams.kubie = 2
                }
            }
            console.log(this.queryParams.kubie)
        },
        async handleSelect(row){ 
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getIsHaveZfxx&dwmc=${escape(row.dwmc)}`)
            console.log(data.data)
            let res = '您是否确定要对该单位案件受理吗?'
            if(data.data.num1.length > 0){
                let arr = []
                data.data.num1.forEach(item => {
                    arr.push(item.lianRq)
                })
                let rq = arr.join(',')
                console.log(rq)
                res = '此单位有案子正在进行中，立案日期为('+rq+')，确定对这家单位办理新案子吗？'
            }else{
                res = '您是否确定要对该单位案件受理吗?'
            }
            let that = this
            this.$confirm(res, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                that.dwId = row.mid
                that.dwFlag = row.dw_flag
                that.isSelect = true
                this.$router.push({path:'/baxq',query:{dwId:row.mid,dwFlag:row.dw_flag,isNew:1,xgType:1}})
            })
        },
        async getPhone(){
            this.open = true
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblByMobile&c_mid=${this.cmid}&dwmc=${escape(this.queryParams.dwmc)}&dwmc2=${escape(this.queryParams2.dwmc)}&mid=&type=shouji`)
            if(data.data){
                this.xcblList = data.data
            }
        },
        //接收身份证智能识别通知
        getSfsb(){

        },
        handleBack(){
            this.isSelect = false
            this.$forceUpdate()
        },
        queding(){
            this.open = false
        },
        handleSelect2(row){
            console.log(row)
        },
    }
}
</script>


<style scoped>
</style>